// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portfolio-screen{
  position: relative;
  margin-top: 20px;
  /*TEXT FONT*/
  font-family: Inter;
  font-style: normal;
}


/* MAIN CONTENT START*/
.singleContent-container-NA {
  position: relative;
  margin-left: var(--content-space);
  margin-right: var(--content-space);
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--white-base);

  /* TEXT FONT */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 18px */
}
/* MAIN CONTENT END*/
.portfolio-title{
  font-size: 34px;
  font-weight: 700;
  line-height: 44px;
  letter-spacing: -0.56px;
}

.portfolio-content{
  margin-top: 30px;
    display: flex;
    flex-direction: row;
    height: fit-content;
    /* Stack the children vertically */
    /* Stretch children to match the container's width */
    position: relative;
    display: flex;
    /* Align children in a row */
    flex-direction: row;
    justify-content: space-between;
    /* Distribute space between children */
    /* TEXT FONT */
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}

.cashinfo-container {
  position: relative;
  height: fit-content;
  display: flex;
  justify-content: center; /* Center content horizontally */
  align-items: center; 
}

.cashinfo {
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--white-base);
  padding: 20px;
  margin: 10px 20px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.cashinfo-title {
  
  /* TEXT FONT */
  font-size: 16px;
  font-weight: 700;
  line-height: 16px; /* 100% */
  letter-spacing: -0.144px;
}

.cashinfo-maincontent {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center; /* Center content horizontally */
  align-items: center;
  gap: 20px;
}

.cashinfo-maincontent-number {
  /* TEXT FONT */
  font-size: 28px;
  font-weight: 700;
  line-height: 34.602px;

}

.cashinfo-maincontent-movement {
  /* TEXT FONT */
  font-family: Inter;
  font-style: normal;
  font-size: 16px;
  font-weight: 700;
  line-height: 28px; /* 175% */
  letter-spacing: -0.144px;
  
}

.cashinfo-maincontent-movement.up {
  color: var(--accents-verdepom); /* Color for up arrow */
}

.cashinfo-maincontent-movement.down {
  color: var(--accents-alizarin-red); /* Color for down arrow */
}

.cashinfo-year {
  /* TEXT FONT */
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/pages/PortfolioTabelle.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;;EAE7B,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kCAAkC;IAClC,oDAAoD;IACpD,kBAAkB;IAClB,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;IACtC,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB,EAAE,gCAAgC;EACzD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAE,gCAAgC;EACzD,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;;AAEvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,wBAAwB;;AAE1B;;AAEA;EACE,8BAA8B,EAAE,uBAAuB;AACzD;;AAEA;EACE,kCAAkC,EAAE,yBAAyB;AAC/D;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".portfolio-screen{\r\n  position: relative;\r\n  margin-top: 20px;\r\n  /*TEXT FONT*/\r\n  font-family: Inter;\r\n  font-style: normal;\r\n}\r\n\r\n\r\n/* MAIN CONTENT START*/\r\n.singleContent-container-NA {\r\n  position: relative;\r\n  margin-left: var(--content-space);\r\n  margin-right: var(--content-space);\r\n  margin-bottom: 40px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--white-base);\r\n\r\n  /* TEXT FONT */\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 150%; /* 18px */\r\n}\r\n/* MAIN CONTENT END*/\r\n.portfolio-title{\r\n  font-size: 34px;\r\n  font-weight: 700;\r\n  line-height: 44px;\r\n  letter-spacing: -0.56px;\r\n}\r\n\r\n.portfolio-content{\r\n  margin-top: 30px;\r\n    display: flex;\r\n    flex-direction: row;\r\n    height: fit-content;\r\n    /* Stack the children vertically */\r\n    /* Stretch children to match the container's width */\r\n    position: relative;\r\n    display: flex;\r\n    /* Align children in a row */\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    /* Distribute space between children */\r\n    /* TEXT FONT */\r\n    font-family: Poppins;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 150%;\r\n}\r\n\r\n.cashinfo-container {\r\n  position: relative;\r\n  height: fit-content;\r\n  display: flex;\r\n  justify-content: center; /* Center content horizontally */\r\n  align-items: center; \r\n}\r\n\r\n.cashinfo {\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--white-base);\r\n  padding: 20px;\r\n  margin: 10px 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n}\r\n\r\n.cashinfo-title {\r\n  \r\n  /* TEXT FONT */\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  line-height: 16px; /* 100% */\r\n  letter-spacing: -0.144px;\r\n}\r\n\r\n.cashinfo-maincontent {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center; /* Center content horizontally */\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n\r\n.cashinfo-maincontent-number {\r\n  /* TEXT FONT */\r\n  font-size: 28px;\r\n  font-weight: 700;\r\n  line-height: 34.602px;\r\n\r\n}\r\n\r\n.cashinfo-maincontent-movement {\r\n  /* TEXT FONT */\r\n  font-family: Inter;\r\n  font-style: normal;\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  line-height: 28px; /* 175% */\r\n  letter-spacing: -0.144px;\r\n  \r\n}\r\n\r\n.cashinfo-maincontent-movement.up {\r\n  color: var(--accents-verdepom); /* Color for up arrow */\r\n}\r\n\r\n.cashinfo-maincontent-movement.down {\r\n  color: var(--accents-alizarin-red); /* Color for down arrow */\r\n}\r\n\r\n.cashinfo-year {\r\n  /* TEXT FONT */\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  line-height: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
